import React from 'react'
import Mhero2Hero from '../../components/pages/MHERO2/Mhero2Hero/Mhero2Hero'
import TechnicalSpecs2 from '../../components/pages/MHERO2/TechnicalSpecs/TechnicalSpecs2'
import ExteriorInterior from '../../components/pages/MHERO2/ExteriorInterior/ExteriorInterior'
import Features2 from '../../components/pages/MHERO2/Features/Features2'
import Warranty2 from '../../components/pages/MHERO2/Warranty/Warranty2'
import Footer from '../../components/pages/MHERO1/Footer'
import BackToVehicleModels from '../../components/BackToVehicleModels/BackToVehicleModels'
import Mhero2Extras from '../../components/pages/MHERO2/Mhero2Extras/Mhero2Extras'

const Mhero2 = () => {
  return (
    <div>
      <Mhero2Hero/>
      <Warranty2/>
      <TechnicalSpecs2/>
      <ExteriorInterior/>
      <Mhero2Extras/>
      <Features2/>
      <BackToVehicleModels variant="dark" />
      <Footer/>
    </div>
  )
}

export default Mhero2